import SearchInput from '@atoms/SearchInput/SearchInput';
import { SEARCH_SUGGESTIONS_PER_PAGE } from '@constants';
import Modal from '@molecules/Modal/Modal';
import SearchResults from '@molecules/SearchResults/SearchResults';
import SearchWrapper from '@organisms/Search/SearchWrapper';
import PropTypes from 'prop-types';

const SUGGESTIONS_ID = 'search-suggestions';
const SEARCH_BODY_CLASS = 'search-modal-active';

export default function SearchSuggestionsModal({ show, onClose, id }) {
  return (
    <Modal
      id={id}
      show={show}
      onClose={onClose}
      title="Waar kunnen we je mee helpen?"
      modifierClass="searchModal"
      bodyClass={SEARCH_BODY_CLASS}
    >
      <SearchWrapper hitsPerPage={SEARCH_SUGGESTIONS_PER_PAGE}>
        <SearchInput controls={SUGGESTIONS_ID} />
        <SearchResults id={SUGGESTIONS_ID} isSearchModal />
      </SearchWrapper>
    </Modal>
  );
}

SearchSuggestionsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
